export enum PayMethod {
  CREDIT_CARD = "100000000000", // 신용카드
  BANK_TRANSFER = "010000000000", // 계좌이체
  VIRTUAL_ACCOUNT = "001000000000", // 가상계좌
  POINT = "000100000000", // 포인트
  MOBILE = "000010000000", // 휴대폰
  GIFT_CARD = "000000001000", // 상품권
  PAY_LATER = "000000000100", // 후불결제
}

export const payMethodDisplayNames = {
  [PayMethod.CREDIT_CARD]: "카드 결제",
  [PayMethod.BANK_TRANSFER]: "계좌이체",
  [PayMethod.VIRTUAL_ACCOUNT]: "가상계좌 (무통장입금)",
  [PayMethod.POINT]: "포인트",
  [PayMethod.MOBILE]: "휴대폰",
  [PayMethod.GIFT_CARD]: "상품권",
  [PayMethod.PAY_LATER]: "후불결제",
};
